import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import PopupState, { bindMenu, bindTrigger } from "material-ui-popup-state";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import Menu from "@mui/material/Menu";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import ProjectFilter from "src/views/warehouse/ProjectFilter";
import useAuth from "src/hooks/useAuth";
import LocationStatus from "src/views/warehouse/LocationStatus";
import LocationHeight from "src/views/warehouse/LocationHeight";
import LocationTypeFilter from "src/views/warehouse/LocationTypeFilter";
import LocationActive from "src/views/warehouse/LocationActive";

export default function WarehouseFilter({
  warehouseId,
  occupied,
  active,
  selected,
  setSelected,
  setOccupied,
  setActive,
  height,
  setHeight,
  locationTypes,
  setLocationTypes,
  clearFilters,
}) {
  const { user } = useAuth();
  const { settings } = user.company;

  const allProjects = () => {
    setSelected([]);
    clearFilters();
  };

  const hasFilters =
    selected.length > 0 || height || typeof occupied === "boolean" || locationTypes?.length > 0;

  return (
    <Box display="flex" justifyContent="space-between">
      <PopupState variant="popover" popupId="demo-popup-menu">
        {popupState => (
          <React.Fragment>
            <Button
              variant="outlined"
              color="primary"
              sx={{ textTransform: "none" }}
              {...bindTrigger(popupState)}
            >
              <FilterAltOutlinedIcon sx={{ mr: 1 }} />
              Filters
              <KeyboardArrowDownIcon
                sx={{ ml: 0.5, transform: popupState.open ? undefined : "rotate(180deg)" }}
              />
            </Button>
            <Menu {...bindMenu(popupState)} sx={{ maxHeight: "70vh", ".MuiList-root": { p: 0 } }}>
              <Accordion disableGutters>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>Location Height</AccordionSummary>
                <AccordionDetails sx={{ p: 0 }}>
                  <LocationHeight height={height} setHeight={setHeight} />
                </AccordionDetails>
              </Accordion>
              <Accordion disableGutters>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>Location Status</AccordionSummary>
                <AccordionDetails sx={{ p: 0 }}>
                  <LocationStatus occupied={occupied} setOccupied={setOccupied} />
                </AccordionDetails>
              </Accordion>
              <Accordion disableGutters>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>Location Type</AccordionSummary>
                <AccordionDetails sx={{ p: 0 }}>
                  <LocationTypeFilter selected={locationTypes} setSelected={setLocationTypes} />
                </AccordionDetails>
              </Accordion>
              <Accordion disableGutters>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  {settings.filter_field2} Filter
                </AccordionSummary>
                <AccordionDetails sx={{ p: 0, overflowY: "auto", maxHeight: "400px" }}>
                  <ProjectFilter
                    warehouseId={warehouseId}
                    selected={selected}
                    setSelected={setSelected}
                  />
                </AccordionDetails>
              </Accordion>
              <Accordion disableGutters>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>Location Active</AccordionSummary>
                <AccordionDetails sx={{ p: 0 }}>
                  <LocationActive active={active} setActive={setActive} />
                </AccordionDetails>
              </Accordion>
            </Menu>
          </React.Fragment>
        )}
      </PopupState>
      {hasFilters && (
        <Button
          variant="contained"
          color="primary"
          onClick={allProjects}
          sx={{
            ml: 1,
            height: 36,
            textTransform: "none",
          }}
        >
          Clear Filters
        </Button>
      )}
    </Box>
  );
}
